module.exports = __webpack_public_path__ + "static/media/its_help_mob.43ced4b8.svg";